import _negate from 'lodash/negate';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { getPathToBeUpdated } from './tableStateHelpers';
export var getCellError = function getCellError(props) {
  var nestingPath = props.nestingPath,
    tdProps = props.tdProps,
    column = props.column;
  var currentCellField = "".concat(getPathToBeUpdated(nestingPath), ".").concat(column.id);
  return _get(tdProps, "rest.tableErrors.".concat(currentCellField));
};
export var isAChild = function isAChild(props) {
  var _props$nestingPath = props.nestingPath,
    nestingPath = _props$nestingPath === void 0 ? EMPTY_ARRAY : _props$nestingPath;
  return nestingPath.length > 1;
};
export var notAChild = _negate(isAChild);
export var getTableCellChangeHandler = function getTableCellChangeHandler(cellOnChangeHandlers) {
  return function (payload) {
    var columnId = _get(payload, 'params.columnId');
    var cellOnChangeHandler = cellOnChangeHandlers[columnId];
    if (!cellOnChangeHandler) {
      console.error("Column changeHandler not found: ".concat(columnId)); // this should never happen
      return;
    }
    cellOnChangeHandler(payload);
  };
};
export var getTableRowActionHandlers = function getTableRowActionHandlers() {
  var tableActionsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return function (_ref) {
    var getState = _ref.getState,
      setState = _ref.setState,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? EMPTY_OBJECT : _ref$params;
    var actionType = params.actionType;
    var actionHandler = _get(tableActionsMap, actionType);
    if (_isFunction(actionHandler)) {
      actionHandler({
        setState: setState,
        getState: getState,
        params: params
      });
    }
  };
};